import ResponsiveFormBuilder from './xFormBuilderHandlers/ResponsiveFormBuilder';
import DispatchEventsFormBuilder from './xFormBuilderHandlers/DispatchEventsFormBuilder';
import SubmitAnimateFormBuilder from './xFormBuilderHandlers/SubmitAnimateFormBuilder';

// Alpine.directive('[name]', (el, { value, modifiers, expression }, { Alpine, effect, cleanup }) => {})

/**
 * The Alpine x-formbuilder directive handler
 */
const xFormBuilder = function(el, directive, utilities) {

  switch (directive.value) {
    case 'responsive':
      ResponsiveFormBuilder(el, directive, utilities);
      break;
    case 'dispatch-response-events':
      DispatchEventsFormBuilder(el, directive, utilities);
      break;
    case 'animate-submit':
      // Not fully implemented
      SubmitAnimateFormBuilder(el, directive, utilities);
      break;
    default:
      break;
  }

}

export default xFormBuilder;
